import { DateTime } from 'luxon';

import { APIConfig } from 'src/config';

/**
 * Builds the full query variables required to retry the route query.
 * @param {object} props - Found-relay route props.
 * @returns {object|null} Retry variables, or null when a required route param is absent.
 */
function buildTradeRuleSetCommunityRetryVariables(props) {
  const uuid = props?.match?.params?.uuid;
  const meterId = props?.match?.params?.meterId;

  if (!uuid || !meterId) {
    return null;
  }

  const timezone = APIConfig().DEFAULT_TIMEZONE;
  return {
    uuid,
    meterId,
    now: Math.floor(DateTime.local({ zone: timezone }).toSeconds()),
  };
}

export default buildTradeRuleSetCommunityRetryVariables;
